import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('dsss_lang') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('dsss_lang', lang);
  }, [lang]);

  const toggleLanguage = useCallback(() => {
    setLang(prev => (prev === 'en' ? 'es' : 'en'));
  }, []);

  const value = useMemo(() => ({ lang, setLang, toggleLanguage }), [lang, setLang, toggleLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};
